<template>
    <div class="pending-status">
        <div>
            <h4 class="instruction-important">
                {{ $t('Successfully uploaded') }}
            </h4>
            <div class="instruction-important">
                {{ $t('Verification in progress') }}
            </div>
            <div class="instruction">
                {{ $t('documentUploadSuccess') }}
                <StaticLink
                    :shouldCapitalize="false"
                    class="action-text"
                    :path="$WikiPath.Help"
                    label="help"
                    @click.native="$emit('helpClick')"
                />
                {{ $t('if you have any questions') }}
            </div>
        </div>
        <div class="important-box">
            <div class="important-box__left">
                <Icon
                    size="md"
                    class="icon-help_circle"
                />
                <div class="capitalize">
                    {{ $t('status') }}
                </div>
            </div>
            <div class="important-box__right green capitalize">
                {{ $t('in progress') }}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import {
        sendVerifyIdentityEvent,
        AnalyticsKycEvent,
    } from '@accountFederation/modules/idCardVerification/analytics/idVerificationAnalytics';
    import { getIdVerificationStoreGetters } from '@accountFederation/modules/idCardVerification/analytics/idVerificationStoreGetters';

    export default {
        name: 'PendingStatus',
        emits: ['helpClick'],
        mounted() {
            sendVerifyIdentityEvent({
                eventName: AnalyticsKycEvent.VerifyIdentitySubmitted,
                idVerificationStoreGetters: getIdVerificationStoreGetters(),
            });
        },
        computed: {
            ...mapGetters('data/country', {
                serverConfig: 'config',
            }),
        },
    };
</script>
